import React, { useState } from "react";
import { Link } from "react-router-dom";
import {IconChevronDown, IconChevronsLeft, IconChevronsRight} from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

const AthletesGroupsMaterial = ( { headline, type } ) => {
    const [openPanel, setOpenPanel] = useState(false);
    const { t } = useTranslation();

    return (
        <div className="shrink-0 relative">
            <div className="flex items-center justify-center gap-2 pb-4">
                <div className="w-10"></div>
                <h1 className="text-2xl uppercase text-center font-black transform -skew-x-12"
                    onClick={() => setOpenPanel(!openPanel)}
                >
                    {headline}
                </h1>
                <button
                    className="px-2"
                    onClick={() => setOpenPanel(!openPanel)}
                >
                    <IconChevronDown className="text-gray-400 w-6 h-auto"/>
                </button>
            </div>
            <div className={`z-10 absolute w-full bottom-0 transform -mt-px transition-all duration-300 translate-y-full grid ${(openPanel) ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                <div className="overflow-y-hidden">
                    <div className="bg-white flex flex-col gap-2 font-bold text-center items-center">
                        <div>
                            <Link to="/athletes" className="px-2 py-1 flex gap-1 relative before:content-[''] before:absolute before:inset-0 before:transform before:-skew-x-12 hover:before:bg-[var(--light-color)]">
                                <IconChevronsRight className={`w-4 h-auto relative ${(type === "athletes") ? 'opacity-1' : 'opacity-0'}`} />
                               <span className="relative">{t("athletes.headline")}</span>
                                <IconChevronsLeft className={`w-4 h-auto relative ${(type === "athletes") ? 'opacity-1' : 'opacity-0'}`} />
                            </Link>
                        </div>
                        <div>
                            <Link to="/athletes/groups" className="px-2 py-1 flex gap-1 relative before:content-[''] before:absolute before:inset-0 before:transform before:-skew-x-12 hover:before:bg-[var(--light-color)]">
                                <IconChevronsRight className={`w-4 h-auto relative ${(type === "groups") ? 'opacity-1' : 'opacity-0'}`} />
                                <span className="relative">{t("athletesGroups.headline")}</span>
                                <IconChevronsLeft className={`w-4 h-auto relative ${(type === "groups") ? 'opacity-1' : 'opacity-0'}`} />
                            </Link>
                        </div>
                        <div>
                            <Link to="/athletes/equiptment" className="px-2 py-1  flex gap-1 relative before:content-[''] before:absolute before:inset-0 before:transform before:-skew-x-12 hover:before:bg-[var(--light-color)]">
                                <IconChevronsRight className={`w-4 h-auto relative ${(type === "equiptment") ? 'opacity-1' : 'opacity-0'}`} />
                                <span className="relative">{t("athletesEquiptment.headline")}</span>
                                <IconChevronsLeft className={`w-4 h-auto relative ${(type === "equiptment") ? 'opacity-1' : 'opacity-0'}`} />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AthletesGroupsMaterial;
